import { RefreshCw } from 'lucide-react';
import { useVersionCheck } from '../../hooks/useVersionCheck';

// Banner fixo no topo que aparece quando há nova versão do frontend disponível.
// Evita que o usuário fique preso em uma versão antiga quando a aba fica
// aberta por muito tempo sem dar F5.
export function UpdateBanner() {
  const { hasUpdate, reload } = useVersionCheck();
  if (!hasUpdate) return null;

  return (
    <div className="update-banner" role="status">
      <RefreshCw size={16} />
      <span>Uma nova versão do Comunica está disponível.</span>
      <button className="btn btn-sm" onClick={reload}>Atualizar agora</button>
    </div>
  );
}
